import { type EditorPlugin, AllPlugins } from '@aha-app/aha-editor-v2';
import EmbeddedReportComponentPlugin from './EmbeddedReportComponentPlugin';
import EmbeddedReportPastePlugin from './EmbeddedReportPastePlugin';

interface EmbeddedReportPluginOptions {
  allowConfigure: boolean;
  advancedPasteEnabled: boolean;
}

const EmbeddedReportPlugin = (
  options: EmbeddedReportPluginOptions
): EditorPlugin[] => {
  return [
    EmbeddedReportComponentPlugin({ allowConfigure: options.allowConfigure }),
    AllPlugins.EmbeddedReportSchemaPlugin,
    EmbeddedReportPastePlugin({
      advancedPasteEnabled: options.advancedPasteEnabled,
    }),
  ];
};

export default EmbeddedReportPlugin;
